import styled from 'styled-components'

export const Wrapper = styled.div<any>`
  ${props => props.theme.css.container};
  max-width: 700px;
  min-height: 60vh;

  .success {
    text-align: center;
    line-height: 1.5;
  }

  ${props => props.isLivBrite && `
    label {
      font-size: 18px;
    }
  `}
`
